import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"

export const NeonAmount = styled.div`
  color: #5cbca1;
  display: inline-block;
  font-weight: ${fonts.weight.medium};
  font-size: 13px;
`

export const RightNeonAmount = styled(NeonAmount)`
  text-align: right;
`

export const Count = styled.div`
  color: ${colors.gray};
  font-size: 11px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
